export enum AUTH_BACKEND_TYPE {
  AAD = 'azuread-oauth2',
  GOOGLE = 'google-oauth2',
}

export enum AUTH_GRANT_TYPE {
  CONVERT_TOKEN = 'convert_token',
  PASSWORD = 'password',
}
